import * as global from './global'
import * as local from './local'

export interface AppConfig {
  homeUrl: string
  oauthUrl: string
  apiBaseUrl: string
  titlePostfix: string
}

const appConfig: AppConfig = {
  ...global,
  ...local
}

export { appConfig }
